import { Injectable } from "@angular/core";
import { ValidatorService } from "../base/table/validator.service";
import { FormGroup, FormControl, Validators } from "@angular/forms";

@Injectable()
export class TypeAttributesValidationService implements ValidatorService {
    getRowValidator(): FormGroup {
        return new FormGroup({
            typeId: new FormControl(),
            code: new FormControl(),
            name: new FormControl()            
          });
        }
}